import { ISuggestResult } from '../types'

export const searchResultLabel = (e: ISuggestResult) => e.name
export const resultMatch = (a?: ISuggestResult, b?: ISuggestResult) => a?.name === b?.name
